import React from "react";
import Rollbar from '../utils/RollbarTracking'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from 'axios'
import { Link } from 'react-router-dom';
import {Line} from 'react-chartjs-2';
import { toast } from 'react-toastify';

import {PopularProducts} from '../components/dashboard/PopularProducts'

export class Dashboard extends React.Component {

  state = {
      pendingOrders: [],
      ordersThisMonth: [],
      monthlySalesGraph: [],
      totalSales: 0,
      myCustomerData: [],
      todayDelivery: []
  }

  componentDidMount() {
    this.fetchPendingOrderData();
    this.fetchOrdersThisMonth();
    this.fetchTotalSalesThisMonth();
    this.fetchMonthlySalesGraph();
    this.fetchTodaysDeliveries()
    this.fetchCustomerData();
  }

  fetchPendingOrderData = async () => {
    axios.get('/orders/pending')
        .then(data => {
            this.setState({
              pendingOrders: data
            });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to get pending orders')
        })
  }

  acceptAllOrders = async () => {
    axios.post('/orders/acceptall')
        .then(data => {
          toast.success("Orders Accepted!");
          this.fetchPendingOrderData();
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to accept all orders')
        })
  }

  fetchOrdersThisMonth = async () => {
    axios.get('/dashboard/ordersthismonth')
      .then(data => {
        this.setState({
          ordersThisMonth: data, // All orders for this month
        });
      })
      .catch (err => {
        console.error(err);
        Rollbar.error(err)
        toast.error('Failed to get all orders this month')
      })
  }

  fetchTotalSalesThisMonth = async () => {
    axios.get('/dashboard/totalsalesthismonth')
      .then(data => {
        this.setState({
          totalSales: data[0].totalSales ? data[0].totalSales : 0, // Total sales for this month
        });
      })
      .catch (err => {
        console.error(err);
        Rollbar.error(err)
        toast.error('Failed to get total sales this month')
      })
  }

  fetchMonthlySalesGraph = async () => {
    axios.get('/dashboard/monthlysalesgraph')
      .then(data => {
        this.setState({
          monthlySalesGraph: data,
        });
      })
      .catch (err => {
        console.error(err);
        Rollbar.error(err)
        toast.error('Failed to get monthly sales')
      })
  }

  fetchTodaysDeliveries = async () => {
    axios.get('/dashboard/deliveryorderstoday')
      .then(data => {
        this.setState({
          todayDelivery: data,
        });
      })
      .catch (err => {
        console.error(err);
        Rollbar.error(err)
        toast.error('Failed to get todays deliveries')
      })
  }

  fetchCustomerData = async () => {
    axios.get('/customers')
        .then(data => {
          this.setState({
            myCustomerData: data
          });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to get all customers')
        })
  }

  cellButton(cell, row, enumObject, rowIndex) {
    return (
       <Link to={'/orders/view/' + row.orderID}><button type="button" className="btn btn-info btn-sm">View</button></Link>
    )
  }

    render() {
      var firstMonth = new Date();
      firstMonth.setDate(1);
      firstMonth.setMonth(firstMonth.getMonth() - 11);
      var monthLabels = Array.from({length: 12}, function(_, index) {
        var month = new Date(firstMonth);
        month.setMonth(firstMonth.getMonth() + index);
        return month.toLocaleDateString('en', {month: 'long', year: 'numeric'});
      });
      var graphProps = {
        labels: monthLabels,
        datasets: [
          {
            label: 'Sales ($)',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: 'rgba(75,192,192,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 2,
            pointHitRadius: 10,
            data: this.state.monthlySalesGraph
          }
        ]
      };
        return (
          <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Dashboard</h1>
            </div>

            <div className="card-deck">
              <div className="card bg-c-blue order-card">
                <div className="card-block">
                  <h5 className="mb-1">Sales</h5>
                  <h1 className="text-right mb-0"><i className="fa fa-usd f-left"></i><span>${this.state.totalSales.toFixed(0)}</span></h1>
                  <p className="mb-0"><span className="f-right">This Month</span></p>
                </div>
              </div>
              <div className="card bg-c-green order-card">
                <div className="card-block">
                  <h5 className="mb-1">Orders</h5>
                  <h1 className="text-right mb-0"><i className="fa fa-shopping-cart f-left"></i><span>{this.state.ordersThisMonth.length}</span></h1>
                  <p className="mb-0"><span className="f-right">This Month</span></p>
                </div>
              </div>
              <div className="card bg-c-yellow order-card">
                <div className="card-block">
                  <h5 className="mb-1">Customers</h5>
                  <h1 className="text-right mb-0"><i className="fa fa-users f-left"></i><span>{this.state.myCustomerData.length}</span></h1>
                  <p className="mb-0"><span className="f-right">Total</span></p>
                </div>
              </div>
              <div className="card bg-c-pink order-card">
                <div className="card-block">
                  <h5 className="mb-1">Pending</h5>
                  <h1 className="text-right mb-0"><i className="fa fa-edit f-left"></i><span>{this.state.pendingOrders.length}</span></h1>
                  <p className="mb-0"><span className="f-right">Total</span></p>
                </div>
              </div>
            </div>

            <div className="pt-3">
              <h5>Pending Orders</h5>
              <button type="button" onClick={this.acceptAllOrders} className="btn btn-success btn-sm">Accept All</button>
            </div>
            <div className="row">
              <div className="col">
                <BootstrapTable data={this.state.pendingOrders} options={{defaultSortName: 'date', defaultSortOrder: 'desc', sizePerPage: 50}} striped={true} hover={true} pagination>
                      <TableHeaderColumn dataField="orderID" isKey={true} width="55">No.</TableHeaderColumn>
                      <TableHeaderColumn dataField="company" dataSort={true}>Customer</TableHeaderColumn>
                      <TableHeaderColumn dataField="date" dataSort={true}>Date</TableHeaderColumn>
                      <TableHeaderColumn dataField="total">Total</TableHeaderColumn>
                      <TableHeaderColumn dataField="deliveryDay" dataSort={true} width="165">Delivery Day</TableHeaderColumn>
                      <TableHeaderColumn dataFormat={this.cellButton}>Action</TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="pt-2"><h5>Monthly Sales</h5></div>
                <div className="card">
                  <div className="card-body">
                    <Line data={graphProps} />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="pt-2"><h5>Top 10 Products</h5></div>
                <PopularProducts />
              </div>
            </div>

            <div className="pt-3"><h5>Today's Deliveries</h5></div>
            <div className="row mb-3">
              <div className="col">
                <BootstrapTable data={this.state.todayDelivery} striped={true} hover={true} options={{sizePerPage: 50}} pagination>
                      <TableHeaderColumn dataField="orderID" isKey={true}>Order No</TableHeaderColumn>
                      <TableHeaderColumn dataField="company">Customer</TableHeaderColumn>
                      <TableHeaderColumn dataField="total">Total</TableHeaderColumn>
                      <TableHeaderColumn dataFormat={this.cellButton}>Action</TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>

          </div>
        );
    }
}
